import { render, staticRenderFns } from "./v-image-field.vue?vue&type=template&id=b078a65a&"
import script from "./v-image-field.vue?vue&type=script&lang=js&"
export * from "./v-image-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports